<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-20 19:41:59
 * @LastEditTime: 2019-08-26 11:34:16
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div class="floor-component">
    <div ref="wrap" class="wrap">
      <ul ref="floorCtrl" class="floors">
        <li
          v-for="(value,key,index) in floorMapping"
          :key="index"
          class="text-shadow"
          :class="index === mapFocusFloor - 1 ? 'active' : ''"
          @click="changeFloor(key)"
        >{{ value }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  components: {

  },
  props: {
  },
  data () {
    return {
    };
  },
  computed: {
    // 当前聚焦楼层
    mapFocusFloor: {
      get () { return this.$store.state.nav.mapFocusFloor; },
      set (val) { this.$store.commit('nav/set_mapFocusFloor', val); }
    },
    // 地图楼层映射
    floorMapping () {
      return this.$store.getters['nav/floorMapping'];
    }
  },
  watch: {
    mapFocusFloor (val) {
      let floorCount = Object.keys(this.floorMapping).length;
      let ss = this.$refs.floorCtrl.offsetHeight / floorCount;
      this.$refs.wrap.scrollTop = (floorCount - this.mapFocusFloor) * ss;
    }
  },
  created () {

  },
  mounted () {
    this.$nextTick(() => {
      let floorCount = Object.keys(this.floorMapping).length;
      let ss = this.$refs.floorCtrl.offsetHeight / floorCount;
      this.$refs.wrap.scrollTop = (floorCount - this.mapFocusFloor) * ss;
    });
  },
  methods: {
    changeFloor (floor) {
      this.$emit('changeFloor', floor);
    },
    setFloor (floor) {
      this.mapFocusFloor = floor;
    }
  }
};
</script>

<style scoped lang="scss">
@media (orientation: landscape) {
.floor-component{
  overflow: hidden;
  border-radius: 50px;
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
}
.wrap {
  // width: 70px;
  height: 210px;
  overflow-y: auto;
  border-radius: 20px;
  background: $color-opacity-primary;
  ::-webkit-scrollbar {
    display: none;
  }
}
.floors {
  display: flex;
  flex-direction: column-reverse;
  transition: all 0.5s;
  margin: 70px 0;
  li {
    display: flex;
    justify-content: center;
    align-items: center;
    // width: 100%;
    height: 70px;
    font-size: 18px;
    color: $color-white;
  }
  .active {
    background: #1e6186;
  }
}
}
@media (orientation: portrait) {
.floor-component{
  overflow: hidden;
  border-radius: 50px;
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
}
.wrap {
  width: 100%;
  height: 534px;
  overflow-y: auto;
  // border-radius: 20px;
  background: $color-opacity-primary;
}
.floors {
  display: flex;
  flex-direction: column-reverse;
  transition: all 0.5s;
  margin: 70px 0;
  width: 142px;
  text-align: center;
  li {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 128px;
    font-size: 44px;
    color: $color-white;
  }
  .active {
    background: linear-gradient( 180deg, #2DD79A 0%, #0C9962 100%);
  }
}
}
</style>
<style lang="scss">
.floor-component {
  ::-webkit-scrollbar {
    display: none;
  }
}
</style>
